export default __webpack_public_path__ + "static/media/office-bordered.cfb60b49.jpg";